import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <path
        d="M6.28 2A2.27 2.27 0 0 0 4 4.25v67.64a2.24 2.24 0 0 0 .67 1.6 2.28 2.28 0 0 0 1.61.66h52.44a2.28 2.28 0 0 0 1.61-.66 2.24 2.24 0 0 0 .67-1.6V22.74a2.24 2.24 0 0 0-.22-.95l-.1-.2-.13-.19-.09-.11-.05-.06-.08-.09L41.74 2.66a2.27 2.27 0 0 0-1.6-.66Zm2.05 4.33h28.86V22.8a2.29 2.29 0 0 0 2.29 2.29H56v44.73H8.33ZM42.24 10 53 20.76H42.24ZM15.78 33.75a2.17 2.17 0 0 0 .22 4.33h32.68a2.17 2.17 0 0 0 1.56-.62 2.17 2.17 0 0 0 0-3.1 2.21 2.21 0 0 0-1.56-.61h-32.9Zm-.68 11.54a2.16 2.16 0 0 0 .22 4.32h34.04A4 4 0 0 0 51 49a2.25 2.25 0 0 0 0-3.22 16.29 16.29 0 0 0-1.63-1.22h-34a6.07 6.07 0 0 1-.23.72Zm-.28 11.54a2.16 2.16 0 0 0 .18 4.33h32.72a2.16 2.16 0 0 0 1.56-3.71 2.11 2.11 0 0 0-1.56-.61H15a.81.81 0 0 0-.22 0Z"
        fill={colourFill}
      />
    </svg>
  );
};

export default ServiceIcon;
